import { SxProps, Theme } from '@mui/material';

export const ClubDpRewardsTitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-md)',
	color: '#2C2C2C',
	fontWeight: 800,
};

export const ClubDpRewardsSubTitleSX: SxProps<Theme> = (theme) => ({
	width: '100%',
	fontSize: 'var(--font-size-sm)',
	color: '#2C2C2C',
	fontWeight: 800,
	paddingBottom: theme.typography.pxToRem(14),
	textAlign: { xs: 'center', lg: 'left' },
});

export const ClubDpRewardsActionSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	color: 'primary.main',
};

export const ClubDpRewardDescriptionSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
};

export const ClubDpRewardsPaperSX: SxProps<Theme> = (theme) => ({
	display: 'flex',
	flexDirection: 'column',
	width: '50%',
	padding: 3,
	boxShadow: 'none',
	border: '1px solid #E8E8E8',
	marginBottom: theme.typography.pxToRem(18),

	[theme.breakpoints.down('md')]: {
		width: '100%',
	},
});

export const ButtonRewardsSX: SxProps<Theme> = (theme) => ({
	display: 'flex',
	alignItems: 'center',
	width: '60%',
	height: theme.typography.pxToRem(48),
	borderRadius: '40px',
	marginLeft: theme.typography.pxToRem(18),

	[theme.breakpoints.down('md')]: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		marginLeft: '0px',
		marginTop: theme.typography.pxToRem(14),
	},
});

export const ButtonSecondRewardsSX: SxProps<Theme> = (theme) => ({
	display: 'flex',
	alignItems: 'center',
	width: '60%',
	height: theme.typography.pxToRem(48),
	borderRadius: '40px',
	background: '#F1F1F1',
	color: '#333',
	marginLeft: theme.typography.pxToRem(18),
	'&:hover': {
		background: '#011688',
		color: '#FFF',
	},
	[theme.breakpoints.down('md')]: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		marginLeft: '0px',
		marginTop: theme.typography.pxToRem(14),
	},
});

export const ClubDpRewardsCardFrameSX: SxProps<Theme> = (theme) => ({
	width: '100%',
	height: '240px',
	position: 'relative',
	textAlign: 'center',
	overflow: 'hidden',
	borderRadius: '10px',
	boxShadow: '0 16px 40px #7090B033',
	margin: 0,
	padding: 0,
	[theme.breakpoints.down('md')]: {
		width: '351px',
		height: '225px',
	},
});

export const ClubDpRewardsCardLabelSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	color: '#929292',
};

export const ClubDpRewardsCardLabelBlackSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	color: '#333',
};

export const ClubDpRewardsCardHolderSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	color: '#333333',
	fontWeight: 600,
};

export const ClubDpRewardsCardHolderFrameSX = (isMobile: boolean): SxProps<Theme> => ({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	border: '1px solid #E8E8E8',
	width: isMobile ? '100%' : '409px',
	paddingX: 3,
	paddingY: 1.5,
	backgroundColor: '#FFFFFF',
	borderRadius: '6px',
	order: { xs: 2, md: 1 },
});

export const ClubDpRewardsCardPointsFrameSX = (isMobile: boolean): SxProps<Theme> => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	border: '1px solid #E8E8E8',
	width: isMobile ? '100%' : '409px',
	paddingX: 3,
	paddingY: 1.5,
	backgroundColor: '#FFFFFF',
	borderRadius: '6px',
	gap: 1,
	order: { xs: 1, md: 2 },
});

export const ClubDpRewardsCardImgSX: SxProps<Theme> = {
	objectFit: 'cover',
	width: '100%',
	height: '100%',
};

export const ClubDpRewardsCardNumberSX: SxProps<Theme> = {
	position: 'absolute',
	width: '100%',
	top: '45%',
	height: '21px',
	zIndex: 1,
	fontSize: 'var(--font-size-lg)',
	color: '#FFF',
};

export const ClubDpRewardsCardNameSX: SxProps<Theme> = {
	position: 'absolute',
	width: '100%',
	top: '85%',
	right: '25%',
	height: '21px',
	zIndex: 1,
	fontSize: 'var(--font-size-tiny)',
	color: '#FFF',
};

export const ClubDpRewardsCardDateSX: SxProps<Theme> = {
	position: 'absolute',
	width: '100%',
	top: '85%',
	left: '35%',
	height: '21px',
	zIndex: 1,
	fontSize: 'var(--font-size-tiny)',
	color: '#FFF',
};

export const ClubDpRewardsCardSinceSX: SxProps<Theme> = {
	position: 'absolute',
	width: '100%',
	top: '80%',
	left: '32%',
	height: '21px',
	zIndex: 1,
	fontSize: 'var(--font-size-micro)',
	color: '#FFF',
};

export const ClubDpRewardsCardPointsIconSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-xxl)',
	color: '#011688',
};

export const ClubDpRewardsCardPointsSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	fontSize: 'var(--font-size-xl)',
	color: '#011688',
	fontWeight: 'bold',
	gap: 1,
};

export const ClubDpRewardsTableAmountSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-md)',
	color: '#011688',
	fontWeight: 'bold',
	gap: 1,
};

export const ClubDpRewardsDividerSX: SxProps<Theme> = (theme) => ({
	marginTop: theme.typography.pxToRem(30),
	marginBottom: theme.typography.pxToRem(30),
});

export const ClubDpRewardsCollapseSX: SxProps<Theme> = (theme) => ({
	alignSelf: 'flex-start',
	padding: theme.typography.pxToRem(0),
	color: '#011688',
	'& span': {
		margin: 0,
	},
});

export const ClubDpRewardsMonthSelectSX: SxProps<Theme> = {
	minWidth: '120px',
	borderRadius: '40px',
	padding: '0 5px',
	marginLeft: 'auto',
	width: 'auto',
	'& .MuiSelect-icon': {
		color: '#011688',
	},
};

export const ClubDpRewardsTicketsTitleSX: SxProps<Theme> = {
	'& div': {
		'& h2:first-of-type': {
			fontSize: 'var(--font-size-md)',
		},
	},
};
